(function($) {
  var counter = $('.carousel__counter span');
  $('.carousel').slick({
    autoplay: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    dots: false,
    arrows: true
  }).on('afterChange', function(event, slick, currentSlide, nextSlide) {
    counter.text(currentSlide + 1);
  });
})(jQuery);
